module.exports = __webpack_public_path__ + "img/KinokoTable43.1a09a3bb.jpg";